import React, { useEffect, useState, Fragment } from "react";
import {
  Grid,
  makeStyles,
  Typography,
  Box,
  Button,
  DialogContent,
  Dialog,
  FormControlLabel,
} from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";

import styles from "../../../../styles/global-styles";
import { connect } from "react-redux";
import { actions } from "../../../../redux/actions/alert";
import ProductDistributionForm from "../forms/ProductDistributionForm";
import { ChipCatalogueService } from "../../../../services/chipCatalogue.service";
import CustomCheckBox from "../../../stateless/CheckBox";

const usetSyles = makeStyles((theme) => ({
  form: {
    width: "auto", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  backgroundIcon: styles.backgroundIcon,
  numberProducts: {
    marginRight: 20,
    fontSize: 22,
    fontWeight: 800,
  },
}));

const ResumeChipDistribution = ({
  addAlert,
  detailAlert,
  bulkChip,
  detailProduct,
}) => {
  const classes = usetSyles();
  const [checkedId, setCheckedId] = useState([]);
  const [chipsArray, setChipsArray] = useState([]);
  const [checkedAll, setCheckedAll] = useState(false);
  const [chipType, setChipType] = useState("");
  const [openModalDistribution, setOpenModalDistribtuion] = useState(false);

  useEffect(() => {
    const chipsArrayWithChecked = bulkChip.map((item) => {
      return { ...item, checked: false };
    });
    setChipsArray(chipsArrayWithChecked);
    (async function () {
      try {
        const {
          data: { name },
        } = await ChipCatalogueService.getOneChipCatalogue(
          detailProduct.chipCatalogueId
        );
        setChipType(name);
      } catch (error) {
        addAlert({ showAlert: true });
        detailAlert({ severity: "error", message: error.msgs });
      }
    })();
  }, []);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleChipChecked = ({ target: { checked } }, chipId, index) => {
    console.log("iccid select", chipId);
    const copyChipsArray = chipsArray;
    if (checked) {
      copyChipsArray[index] = { ...copyChipsArray[index], checked: true };
      setCheckedId((checkedId) => [...checkedId, chipId]);
    } else {
      copyChipsArray[index] = {
        ...copyChipsArray[index],
        checked: false,
      };
      const newArray = checkedId.filter((item) => item !== chipId);
      setCheckedId(newArray);
    }
    setChipsArray(copyChipsArray);
  };

  const handleCloseModal = (openModal) => setOpenModalDistribtuion(openModal);

  const handleCheckAll = ({ target }) => {
    setCheckedAll(target.checked);
    const copyChipsArray = chipsArray;
    if (target.checked) {
      const idsArray = chipsArray.map((item, index) => {
        copyChipsArray[index] = {
          ...copyChipsArray[index],
          checked: true,
        };
        return item.chipId;
      });
      setCheckedId(idsArray);
    } else {
      setCheckedId([]);
      chipsArray.forEach((_, index) => {
        copyChipsArray[index] = {
          ...copyChipsArray[index],
          checked: false,
        };
      });
    }
    setChipsArray(copyChipsArray);
  };

  return (
    <React.Fragment>
      <Grid
        style={{ marginTop: 20 }}
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
      >
        <Grid item xs={12}>
          <Typography
            variant="h4"
            style={{ fontWeight: "bold" }}
            component={"div"}
          >
            Chip {chipType}
          </Typography>
        </Grid>
        <br></br>
        <Grid item xs={12} style={{ marginTop: "55px" }}>
          <Typography
            variant="h5"
            gutterBottom
            style={{ fontWeight: "lighter" }}
            component={"div"}
          >
            Resumen de registro
          </Typography>
          <div style={{ display: "inline-flex" }}>
            <Typography variant="body1" component={"div"}>
              <Box
                mt={2}
                style={{
                  color: "#1C2668",
                  fontSize: 22,
                  fontWeight: 800,
                  marginRight: 30,
                }}
              >
                <span className={classes.numberProducts}>
                  {checkedId.length}
                </span>
                Productos Seleccionados
              </Box>
            </Typography>
            <FormControlLabel
              control={
                <CustomCheckBox
                  checked={checkedAll}
                  onChange={handleCheckAll}
                  name="checkedG"
                />
              }
              label="Seleccionar todos."
            />
          </div>
        </Grid>

        <Grid item xs={4} md={2} style={{ marginTop: "35px" }}></Grid>
        <Grid
          item
          xs={4}
          md={3}
          style={{ marginTop: "35px", fontSize: 18, fontWeight: 600 }}
        >
          id
        </Grid>
        <Grid
          item
          xs={4}
          md={3}
          style={{ marginTop: "35px", fontSize: 18, fontWeight: 600 }}
        >
          ICCID
        </Grid>
        <Grid item xs={12} md={4} style={{ marginTop: "35px" }}></Grid>
        {chipsArray.map((item, key) => {
          return (
            <Fragment key={key}>
              <Grid item xs={4} md={2} style={{ marginTop: "20px" }}>
                <Checkbox
                  onChange={(e) => {
                    handleChipChecked(e, item.chipId, key);
                  }}
                  checked={item.checked}
                  color="primary"
                  inputProps={{ "aria-label": "secondary checkbox" }}
                />
              </Grid>
              <Grid
                item
                xs={3}
                md={3}
                style={{ marginTop: "20px", fontSize: 18 }}
              >
                {item.chipId}
              </Grid>
              <Grid
                item
                xs={4}
                md={3}
                style={{ marginTop: "20px", fontSize: 18 }}
              >
                {item.iccid}
              </Grid>
              <Grid item xs={12} md={4} style={{ marginTop: "20px" }}></Grid>
            </Fragment>
          );
        })}

        {checkedId.length > 0 && (
          <Grid item xs={12} md={4} style={{ marginTop: "35px" }}>
            <Button
              variant="contained"
              color="primary"
              style={{ marginTop: "20px" }}
              type="submit"
              onClick={() => setOpenModalDistribtuion(true)}
              endIcon={
                <ArrowRightAltIcon
                  className={classes.backgroundIcon}
                  color="primary"
                ></ArrowRightAltIcon>
              }
            >
              Distribución
            </Button>
          </Grid>
        )}
      </Grid>

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        fullScreen={fullScreen}
        open={openModalDistribution}
        onClose={() => setOpenModalDistribtuion(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent style={{ overflow: "hidden" }}>
          <ProductDistributionForm
            onClose={handleCloseModal}
            itemsIdSelected={checkedId}
            detailProduct={detailProduct}
            productType="chip"
          />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(ResumeChipDistribution);
